module.exports = __webpack_public_path__ + "static/media/yp-how-to-date-step2.fbc1555e.webp";